import { searchWithDiacritics } from '@/helpers/searchWithDiacritics';

export const internalUsersFilterMixin = {
  data() {
    return {
      filteredInternalUsers: [],
    };
  },
  watch: {
    internalUsers: {
      immediate: true,
      handler() {
        this.filteredInternalUsers = this.internalUsers;
      },
    },
  },
  methods: {
    internalUsersFilterMethod(query) {
      this.filteredInternalUsers = searchWithDiacritics(query, this.internalUsers, ['fullname']);
    },
    handleInternalUsersVisibleChange() {
      setTimeout(() => {
        this.filteredInternalUsers = this.internalUsers;
      }, 50);
    },
  },
};
